export default __webpack_public_path__ + "static/media/mail.97f32d08.png";